import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'City',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M28 15h-8V6.38c0-.25-.09-.49-.26-.67l-3.5-3.89c-.4-.44-1.09-.44-1.49 0l-3.5 3.89c-.16.19-.25.43-.25.67V9H3c-.55 0-1 .45-1 1v19c0 .55.45 1 1 1h25c.55 0 1-.45 1-1V16c0-.55-.45-1-1-1zM8 27H5v-3h3v3zm0-6H5v-3h3v3zm0-6H5v-3h3v3zm9 12h-3v-3h3v3zm0-6h-3v-3h3v3zm0-6h-3v-3h3v3zm0-6h-3V6h3v3zm9 18h-3v-3h3v3zm0-6h-3v-3h3v3z" }
      })]
    );
  }
};